import apiClient from '../apiClient';

const API_URL = '/tramites/art';

const normalizeItems = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.content)) return payload.content;
    if (payload && Array.isArray(payload.data)) return payload.data;
    return [];
};

const adaptTramiteARTItem = (t = {}) => ({
    ...t,
    idCliente: t.idCliente ?? t.cuilCliente ?? null,
    nombreTipoTramite: t.nombreTipoTramite ?? t.tipoTramite ?? null,
    idEstado: t.idEstado ?? t.idEstadoActual ?? null,
});

const adaptTramitesARTPayload = (payload) => {
    const items = normalizeItems(payload).map(adaptTramiteARTItem);
    if (Array.isArray(payload)) return items;
    return {
        ...(payload || {}),
        content: items,
    };
};

// Obtener todos los trámites ART o filtrar por idCliente y/o estado
export const getTramitesART = async (
    page = 0,
    size = 15,
    idCliente = '',
    idEstadoActual = null,
    nombreApellido = '',
    organismo = null
) => {
    const params = { page, size };

    if (idCliente && String(idCliente).trim() !== '') {
        params.idCliente = String(idCliente).trim();
        params.cuil = String(idCliente).trim();
    }
    if (idEstadoActual !== null && idEstadoActual !== '' && idEstadoActual !== undefined) {
        params.idEstadoActual = idEstadoActual;
        params.idEstado = idEstadoActual;
    }
    if (nombreApellido && String(nombreApellido).trim() !== '') params.nombreApellido = String(nombreApellido).trim();
    if (organismo && String(organismo).trim() !== '') params.organismo = String(organismo).trim();

    const response = await apiClient.get(API_URL, { params });
    return adaptTramitesARTPayload(response.data);
};

export const getResumenTramitesART = async (idCliente = '', idEstadoActual = null, nombreApellido = '', organismo = null) => {
    const params = {};
    if (idCliente && String(idCliente).trim() !== '') params.idCliente = String(idCliente).trim();
    if (idEstadoActual !== null && idEstadoActual !== '' && idEstadoActual !== undefined) params.idEstadoActual = idEstadoActual;
    if (nombreApellido && String(nombreApellido).trim() !== '') params.nombreApellido = String(nombreApellido).trim();
    if (organismo && String(organismo).trim() !== '') params.organismo = String(organismo).trim();

    const response = await apiClient.get(`${API_URL}/resumen`, { params });
    return response.data;
};

// Obtener un trámite ART por ID
export const getTramiteARTById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite ART
export const crearTramiteART = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite ART:', error.response?.data || error.message);
        throw error;
    }
};

// Actualizar trámite ART (campos específicos como aseguradora)
export const actualizarTramiteART = async (idTramite, tramiteData) => {
    const response = await apiClient.put(`${API_URL}/${idTramite}`, tramiteData);
    return response.data;
};

// Evaluar automáticamente condición/plazo ART por CUIL del cliente
export const getEvaluacionArtCliente = async (cuil) => {
    const response = await apiClient.get(`${API_URL}/evaluacion-cliente/${cuil}`);
    return response.data;
};

// Obtener sugerencias de trámites similares/posibles duplicados
export const getTramitesSimilares = async (idTramite) => {
    const response = await apiClient.get(`/art/tramites/${idTramite}/similares`);
    return response.data;
};

// Obtener trámites ART para reportes (sin paginación, con filtros de fecha)
export const getReporteTramitesART = async (fechaDesde = null, fechaHasta = null) => {
    const params = { size: 10000 }; // Traer muchos registros sin paginar

    if (fechaDesde && String(fechaDesde).trim() !== '') {
        params.fechaDesde = String(fechaDesde).trim();
    }
    if (fechaHasta && String(fechaHasta).trim() !== '') {
        params.fechaHasta = String(fechaHasta).trim();
    }

    const response = await apiClient.get(`${API_URL}/reportes`, { params });
    return adaptTramitesARTPayload(response.data);
};
